const [usePwaDeps, providePwaDeps] = createEntityDeps<{
  isAuthenticated: Ref<boolean>
}>('pwa')

export { usePwaDeps, providePwaDeps }
